import {
  Box,
  useTheme,
  Text,
  Skeleton,
  Button,
  Flex,
  InputGroup,
  InputRightElement,
  Icon,
  Select,
} from "@chakra-ui/react";
import React from "react";
import { Theme } from "../../theme";
import getAxios from "../../hooks/useAxios";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { FaArrowRight } from "react-icons/fa";
import { MdArrowBackIosNew, MdArrowForwardIos, MdSearch } from "react-icons/md";
import Input from "../../components/CustomInput";

function Activity() {
  const theme = useTheme<Theme>();
  const axios = getAxios();
  const access_token = Cookies.get("x-admin-auth");
  const [activities, setActivities] = React.useState<any>([]);
  const [pageNumber, setPageNumber] = React.useState(() => {
    return Number(localStorage.getItem("activitypage")) || 1;
  });
  const [totalPages, setTotalPages] = React.useState<number>();
  const [totalActivities, setTotalActivities] = React.useState<number>();
  const [isDataFetching, setIsDataFetching] = React.useState(true);
  const [nextNotAllowed, setNextNotAllowed] = React.useState(false);
  const [refetchUrl, setRefetchUrl] = React.useState("/activities?page=1");
  const [searchMobile, setSearchMobile] = React.useState("");
  const [researchData, setResearchData] = React.useState<string>();

  const [startDate, setStartDate] = React.useState("");
  const [endDate, setEndDate] = React.useState("");

  const [role, setRole] = React.useState("");

  const formatToDDMMYYYY = (dateString: any) => {
    if (!dateString) return "";

    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  };
  const getActivities = async (url: string) => {
    setIsDataFetching(true);
    try {
      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      setActivities(res.data.data);
      setTotalPages(res.data.pagination.totalPages);
      setTotalActivities(res.data.pagination.total);
      if (res.data.length < 20) {
        setNextNotAllowed(true);
      } else {
        setNextNotAllowed(false);
      }
    } catch (error) {
      console.log("error listing activity", error);
    } finally {
      setIsDataFetching(false);
    }
  };

  const handleSearchData = (val: string) => {
    if (searchMobile !== "") {
      getActivities(`/activities?mobile=${searchMobile}`);
    } else {
      getActivities(refetchUrl);
    }
  };

  const handleFilterByRole = (val: string) => {
    setRole(val);
  };

  const buildDriverUrl = () => {
    let url = `/activities?page=${pageNumber}`;

    if (role && role !== "all") {
      url += `&role=${role}`;
    }

    if (startDate && endDate) {
      url += `&start_date=${formatToDDMMYYYY(startDate)}`;
      url += `&end_date=${formatToDDMMYYYY(endDate)}`;
    }
    return url;
  };

  const fetchDrivers = () => {
    getActivities(buildDriverUrl());
  };

  React.useEffect(() => {
    fetchDrivers();
  }, [pageNumber, researchData, role, startDate, endDate]);

  React.useEffect(() => {
    if (totalPages && totalPages === pageNumber) {
      setNextNotAllowed(true);
    } else {
      setNextNotAllowed(false);
    }
  }, [totalPages]);

  return (
    <Box sx={{ height: "100%", width: "100%", padding: "0 1rem" }}>
      <Flex
        sx={{
          margin: "2.5rem 0 2rem 2rem",
          gap: "1rem",
          alignItems: "baseline",
        }}
      >
        <Text
          sx={{
            fontSize: theme.fontSizes.subHeading1,
          }}
        >
          App Activities and History
        </Text>
        <Flex sx={{ flex: 1, justifyContent: "flex-end" }}>
          <Text
            sx={{
              fontSize: theme.fontSizes.body,
              marginRight: "0.25rem",
            }}
          >
            Total:
          </Text>
          <Skeleton isLoaded={!isDataFetching}>
            <Text
              sx={{
                fontSize: theme.fontSizes.body,
                color: "green",
              }}
            >
              {totalActivities}
            </Text>
          </Skeleton>
        </Flex>
      </Flex>

      <Flex
        sx={{
          gap: "1rem",
          paddingLeft: "2rem",
          marginBottom: "2rem",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Flex sx={{ gap: "1rem" }}>
          <Box sx={{ height: "100%" }}>
            <InputGroup>
              <InputRightElement
                h="100%"
                cursor={"pointer"}
                onClick={() => handleSearchData("mobile")}
              >
                <MdSearch color={theme.colors.secondary.main} size={20} />
              </InputRightElement>
              <Input
                variant={"outline"}
                placeholder="Search by number"
                sx={{
                  height: "100%",
                }}
                borderColor={theme.colors.secondary.main}
                onChange={(e) => {
                  if (e.target.value !== "") {
                    setSearchMobile(e.target.value);
                  } else {
                    setResearchData(`again_${Math.random()}`);
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSearchData("mobile");
                  }
                }}
              />
            </InputGroup>
          </Box>

          <Box sx={{ height: "100%" }}>
            <Select
              style={{ height: "3.3rem", width: "10rem" }}
              placeholder="Select Role"
              value={role}
              onChange={(e) => handleFilterByRole(e.target.value)}
            >
              <option value="all">All</option>
              <option value="rider">Rider</option>
              <option value="driver">Driver</option>
            </Select>
          </Box>

          <Flex sx={{ alignItems: "center", gap: "0.5rem", height: "100%" }}>
            <Input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              style={{ height: "3.3rem" }}
            />
            <Input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              style={{ height: "3.3rem" }}
            />
          </Flex>
        </Flex>
      </Flex>

      <Box sx={{ marginTop: "1rem", paddingX: "2rem" }}>
        <Skeleton isLoaded={isDataFetching ? false : true} minHeight={"20rem"}>
          {activities.length !== 0 ? (
            <Skeleton
              isLoaded={activities ? true : false}
              minWidth={"580px"}
              width={"74vw"}
            >
              <ViewersTable data={activities} theme={theme} />
            </Skeleton>
          ) : (
            <Text>No data available</Text>
          )}
        </Skeleton>
        <Box
          sx={{
            marginTop: theme.space.xl,
          }}
        >
          <Flex
            sx={{
              justifyContent: "flex-end",
              alignItems: "center",
              gap: "3rem",
            }}
          >
            <Box>
              <Flex
                sx={{
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "0.5rem",
                }}
              >
                <Flex
                  sx={{
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "50%",
                    width: "2rem",
                    height: "2rem",
                  }}
                >
                  <Icon
                    as={MdArrowBackIosNew}
                    boxSize={5}
                    color={theme.colors.primary.main}
                    cursor={pageNumber !== 1 ? "pointer" : "not-allowed"}
                    onClick={() => {
                      if (pageNumber !== 1) {
                        setPageNumber(pageNumber - 1);
                        localStorage.setItem(
                          "activitypage",
                          `${pageNumber - 1}`,
                        );
                        setRefetchUrl(`/activities?page=${pageNumber - 1}`);
                      }
                    }}
                  />
                </Flex>
                <Text variant={"caption"}>Previous Page</Text>
              </Flex>
            </Box>
            <Skeleton
              isLoaded={isDataFetching ? false : true}
              sx={{ width: "2rem" }}
            >
              <Text variant={"body"}>{pageNumber}</Text>
            </Skeleton>
            <Box>
              <Flex
                sx={{
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "0.5rem",
                }}
              >
                <Text variant={"caption"}>Next Page</Text>
                <Flex
                  sx={{
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "50%",
                    width: "2rem",
                    height: "2rem",
                  }}
                >
                  <Icon
                    as={MdArrowForwardIos}
                    boxSize={5}
                    color={theme.colors.primary.main}
                    cursor={nextNotAllowed ? "not-allowed" : "pointer"}
                    onClick={() => {
                      if (!nextNotAllowed) {
                        setPageNumber(pageNumber + 1);
                        localStorage.setItem(
                          "activitypage",
                          `${pageNumber + 1}`,
                        );
                        setRefetchUrl(`/activities?page=${pageNumber + 1}`);
                      }
                    }}
                  />
                </Flex>
              </Flex>
            </Box>
          </Flex>
        </Box>
      </Box>
    </Box>
  );
}

export default Activity;

type ViewerstableType = {
  data?: any;
  theme: Theme;
};

function ViewersTable({ data, theme }: ViewerstableType) {
  const navigate = useNavigate();
  const removeExtraPaddingStyle = {
    WebkitPaddingStart: 0,
    paddingInlineStart: 0,
    WebkitPaddingEnd: 0,
    paddingInlineEnd: "1rem",
  };
  return (
    <div style={{ overflowX: "auto", maxWidth: "100%" }}>
      <table style={{ minWidth: "800px" }}>
        <thead>
          <tr>
            <th style={{ ...removeExtraPaddingStyle, paddingLeft: "1rem" }}>
              <Text
                sx={{
                  fontSize: theme.fontSizes.subHeading2,
                }}
              >
                Sl. No.
              </Text>
            </th>

            <th style={{ ...removeExtraPaddingStyle, paddingLeft: "1rem" }}>
              <Text
                sx={{
                  fontSize: theme.fontSizes.subHeading2,
                }}
              >
                Meta data
              </Text>
            </th>
            <th style={removeExtraPaddingStyle}>
              <Text
                sx={{
                  fontSize: theme.fontSizes.subHeading2,
                }}
              >
                Name
              </Text>
            </th>
            <th style={removeExtraPaddingStyle}>
              <Text
                sx={{
                  fontSize: theme.fontSizes.subHeading2,
                }}
              >
                Mobile
              </Text>
            </th>
            <th style={removeExtraPaddingStyle}>
              <Text
                sx={{
                  fontSize: theme.fontSizes.subHeading2,
                }}
              >
                Type
              </Text>
            </th>
            <th style={removeExtraPaddingStyle}>
              <Text
                sx={{
                  fontSize: theme.fontSizes.subHeading2,
                }}
              >
                Role
              </Text>
            </th>
          </tr>
        </thead>
        <tbody>
          {data.map((item: any, index: number) => (
            <tr key={index}>
              <td style={{ ...removeExtraPaddingStyle, paddingLeft: "1rem" }}>
                <Text
                  sx={{
                    fontSize: theme.fontSizes.body,
                  }}
                >
                  {index + 1}
                </Text>
              </td>

              <td style={{ ...removeExtraPaddingStyle, paddingLeft: "1rem" }}>
                {item?.meta ? (
                  Object.entries(item?.meta).map(([key, value]) => (
                    <Flex key={key} alignItems={"center"} gap={" 1rem"}>
                      <Text
                        sx={{
                          fontSize: theme.fontSizes.body,
                        }}
                      >
                        {key}:
                      </Text>

                      <Text
                        sx={{
                          fontSize: 15,
                          color: "#848484",
                        }}
                      >
                        {String(value)}
                      </Text>
                    </Flex>
                  ))
                ) : (
                  <Text
                    sx={{
                      fontSize: theme.fontSizes.body,
                    }}
                  >
                    N/A
                  </Text>
                )}
              </td>
              <td style={removeExtraPaddingStyle}>
                <Text
                  sx={{
                    fontSize: theme.fontSizes.body,
                  }}
                >
                  {item.name}
                </Text>
              </td>
              <td style={removeExtraPaddingStyle}>
                <Text
                  sx={{
                    fontSize: theme.fontSizes.body,
                  }}
                >
                  {item.mobile}
                </Text>
              </td>

              <td style={removeExtraPaddingStyle}>
                <Text
                  sx={{
                    fontSize: theme.fontSizes.body,
                  }}
                >
                  {item.type}
                </Text>
              </td>

              <td style={removeExtraPaddingStyle}>
                <Text
                  sx={{
                    fontSize: theme.fontSizes.body,
                  }}
                >
                  {item.role}
                </Text>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
